<ion-header>
  <ion-toolbar>
    <ion-title>TEST CONTAINER</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="blue-purple-gradient montserrat">
</ion-content>
